import axios from "axios";
import Constants from "../../../components.constants.js"

export default {

    async getSearchActionsFromServer(context, payload = {}) {

        try {
            let resp = await axios.get(`${Constants.searchFiltersUrl}/${payload.name}?filters=["size","duration"]`, payload);
            if (resp.status == 200) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getSearchActionsFromServer][Store][Error occured while getting search actions--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    if (typeof(error.response.data) == "object") {
                        error.response.data.statusCode = error.response.status
                    } else {
                        error.response.data = { files: error.response.data, statusCode: error.response.status }
                    }
                    return error.response.data
                }
            }
            return {}
        }
    },

    async getConfiguredSearchActionsFromServer(context, payload = {}) {

      try {
          let resp = await axios.get(`${Constants.searchFilterConfigURL}/${payload.name}?filters=["size","duration"]`, payload);
          if (resp.status == 200) {
              resp.data.statusCode = resp.status
              return resp.data;
          } else {
              throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
          }
      } catch (error) {
          console.error(
              `[getConfiguredSearchActionsFromServer][Store][Error occured while getting search actions--->${error}]`
          );
          if (error.response) {
              if (error.response.status == 401) {
                  return context.dispatch("users/logOutFromServer", {}, { root: true })
              } else {
                  if (typeof(error.response.data) == "object") {
                      error.response.data.statusCode = error.response.status
                  } else {
                      error.response.data = { files: error.response.data, statusCode: error.response.status }
                  }
                  return error.response.data
              }
          }
          return {}
      }
  },

    async updateSearchedData(context, payload = {}) {
        try {
            let resp = await axios.post(Constants.searchUrl, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                console.log(
                    `[updateSearchedData][Store][Job post resp-->${resp.status}]`
                );
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[updateSearchedData][Store][Error occured while Posting job--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }

    },

    async updateGlobalFilters(context, payload = {}) {
        //payload : {params:{ScreenId: "23412123"}, data:DAM Users JSON schema}
    
        try {
          let resp = await axios.put(`${Constants.searchFiltersUrl}/global/${payload.name}`, payload);
          if (Constants.acceptedStatusCodes.includes(resp.status)) {
            console.log(
              `[updateGlobalFilters][Store][Screen update resp-->${resp.status}]`
            );
            resp.data.statusCode = resp.status
            return resp.data;
          } else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
          }
        } catch (error) {
          console.error(
            `[updateGlobalFilters][Store][Error occured while updating Screen--->${error}]`
          );
          if (error.response) {
            if (error.response.status == 401){
              return context.dispatch("users/logOutFromServer", {},{root:true})
            }
            else {
              error.response.data.statusCode = error.response.status
              return error.response.data
            }
          }
          return {}
        }
      },

      async updateUserFilters(context, payload = {}) {
        //payload : {params:{ScreenId: "23412123"}, data:DAM Users JSON schema}
    
        try {
          let resp = await axios.put(`${Constants.searchFiltersUrl}/user/${payload.name}`, payload);
          if (Constants.acceptedStatusCodes.includes(resp.status)) {
            console.log(
              `[updateUserFilters][Store][Screen update resp-->${resp.status}]`
            );
            resp.data.statusCode = resp.status
            return resp.data;
          } else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
          }
        } catch (error) {
          console.error(
            `[updateUserFilters][Store][Error occured while updating Screen--->${error}]`
          );
          if (error.response) {
            if (error.response.status == 401){
              return context.dispatch("users/logOutFromServer", {},{root:true})
            }
            else {
              error.response.data.statusCode = error.response.status
              return error.response.data
            }
          }
          return {}
        }
      },
    
};